const locale = {
	// #region Kpis Goals section
	TAB_KPIS_GOALS: 'Obiettivi KPI',
	TAB_KPIS_GOALS_VALUES: 'Valore Obiettivi KPI',

	DIALOG_KPIS_GOALS_DIALOG_ADD_TITLE: 'Aggiungi Obiettivo KPI',
	DIALOG_KPIS_GOALS_DIALOG_EDIT_TITLE: 'Modifica Obiettivo KPI',

	BUTTON_KPI_GOAL_NEW: 'Aggiungi Obiettivo',

	DETAILS_KPIS_GOALS_FIELD_KPI: 'KPI',
	DETAILS_KPIS_GOALS_FIELD_DATE_FROM: 'Data da',
	DETAILS_KPIS_GOALS_FIELD_DATE_TO: 'Data a',
	DETAILS_KPIS_GOALS_FIELD_STATUS: 'Stato Obiettivo KPI',
	DETAILS_KPIS_GOALS_FIELD_CLAUSE: 'Condizione',
	DETAILS_KPIS_GOALS_FIELD_CLAUSE_GREATER: 'Maggiore',
	DETAILS_KPIS_GOALS_FIELD_CLAUSE_SMALLER: 'Minore',
	DETAILS_KPIS_GOALS_FIELD_CURRENT_VALUE: 'Valore corrente',
	DETAILS_KPIS_GOALS_FIELD_TARGET_VALUE: 'Valore obiettivo',
	DETAILS_KPIS_GOALS_FIELD_RESIDUAL_VALUE: 'Valore residuo',
	DETAILS_KPIS_GOALS_FIELD_PROGRESS: 'Progresso',
	DETAILS_KPIS_GOALS_FIELD_AGGREGATION_TITLE: 'Elemento collegato',

	// DETAILS_KPIS_GOALS_FIELD_MODULE_APPLYTOALL: 'Applica a tutti gli elementi di tipo "{{type}}"'
	DETAILS_KPIS_GOALS_FIELD_MODULE_APPLYTOALL: 'Applica a tutti gli elementi'
	// #endregion
};

export default locale;
